import React from 'react'
import TellMeAboutBanner from './Components/TellMeAboutBanner'
import TellMeAboutBody from './Components/TellMeAboutBody'
import IndexFooter from '../Index/Components/IndexFooter'
// import TopBar from '../ProjectComponents/TopBar'
import SEOHelmet from '../ProjectComponents/SEOHelmet'

function TellMeAboutPage() {
  const page ='tell-me-about';
  return (
    <>
        {/* topbar */}
        <SEOHelmet page={page} />
        <div className='bg-main main'>
          {/* <TopBar/> */}
            <TellMeAboutBanner/>
        </div>
            <TellMeAboutBody/>
        <IndexFooter/>
    </>
  )
}

export default TellMeAboutPage